import { createSelector } from '@reduxjs/toolkit';
import { RootSelector } from '../../models/rootSelector';
import { getSelectedNodesInAllFolders } from '../fileManager/selectors/selectors';
import { Tag } from '../../../general/model';
import { UserAccessRight } from '../../../general/model';
import { TagShape, TagOption } from './model';
import _ from 'lodash';

export const getTag: RootSelector<TagShape> = (store) => store.tag;

export const getTagsButtonEnabled: RootSelector<boolean> = createSelector(
  [getSelectedNodesInAllFolders],
  (nodes) => nodes.filter((node) => node.perms.includes(UserAccessRight.write)).length > 0,
);

export const getAllTags: RootSelector<Tag[]> = createSelector([getTag], (tag) => {
  // Введенные юзером новые теги (с временныым отрицательным id)
  const newTags = tag.tagsSelected.filter((t) => t.id < 0);

  return [...newTags, ...tag.tagsLoaded];
});

export const getAllTagsById: RootSelector<Record<number, Tag>> = createSelector(
  getAllTags,
  (allTags) => _.keyBy(allTags, 'id'),
);

export const getDropdownValue: RootSelector<number[]> = createSelector(getTag, (tag) =>
  tag.tagsSelected.map((t) => t.id),
);

export const getDropdownOptions: RootSelector<TagOption[]> = createSelector(
  [getAllTags],
  (allTags) => allTags.map((tag) => ({ label: tag.name, value: tag.id })),
);
